import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const DatabaseIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2 4.5V3.5C2 2.11929 4.68629 1 8 1C11.3137 1 14 2.11929 14 3.5V4.5C14 5.88071 11.3137 7 8 7C4.68629 7 2 5.88071 2 4.5Z"
		/>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2 3.5V4.5C2 5.0628 2.44633 5.58217 3.19956 6C3.25478 6.03063 3.31165 6.06072 3.37011 6.09023C4.4706 6.64585 6.13604 7 8 7C9.96298 7 11.7058 6.60722 12.8004 6C13.5537 5.58217 14 5.06281 14 4.5V3.5C14 2.11929 11.3137 1 8 1C4.68629 1 2 2.11929 2 3.5ZM2.0854 7.07731C2.02925 7.21471 2 7.35593 2 7.5V8.5C2 9.06281 2.44633 9.58217 3.19956 10C4.29421 10.6072 6.03702 11 8 11C9.86396 11 11.5294 10.6459 12.6299 10.0902C12.6884 10.0607 12.7452 10.0306 12.8004 10C13.5537 9.58217 14 9.0628 14 8.5V7.5C14 7.35593 13.9707 7.21472 13.9146 7.07732C13.5739 7.30345 13.2012 7.49336 12.8196 7.65238C11.5102 8.19793 9.8054 8.5 8 8.5C6.1946 8.5 4.48976 8.19793 3.18044 7.65238C2.79877 7.49336 2.42614 7.30345 2.0854 7.07731ZM2.0854 11.0773C2.02925 11.2147 2 11.3559 2 11.5V12.5C2 13.8807 4.68629 15 8 15C11.3137 15 14 13.8807 14 12.5V11.5C14 11.3559 13.9707 11.2147 13.9146 11.0773C13.5739 11.3035 13.2012 11.4934 12.8196 11.6524C11.5102 12.1979 9.8054 12.5 8 12.5C6.1946 12.5 4.48976 12.1979 3.18044 11.6524C2.79877 11.4934 2.42614 11.3035 2.0854 11.0773Z"
		/>
	</svg>
))
